module.exports = __webpack_public_path__ + "img/12.5fb07d84.png";